let current = null;
let generation = 0;
export function setRequestPreview(value) { current = value; generation += 1; }
export function requestPreview() { return current; }
export function preparePreviewRequest(config) {
  const control = config.previewControl === true && ['/auth/me', '/auth/preview-organizations'].includes(config.url);
  config.previewGeneration = generation;
  config.previewControl = control;
  if (current && !control) {
    if ((config.method || 'get').toLowerCase() !== 'get') {
      throw new Error('Weergavevoorbeeld is alleen-lezen. Stop het voorbeeld om wijzigingen te maken.');
    }
    config.headers = config.headers || {};
    config.headers['X-THRM-Preview-Role'] = current.role;
    config.headers['X-THRM-Preview-Organization'] = current.organization_id || '';
  }
  return config;
}
export function validatePreviewResponse(response) {
  if (!response.config?.previewControl && response.config?.previewGeneration !== generation) {
    throw new Error('Weergave gewijzigd; verouderd antwoord genegeerd.');
  }
  return response;
}
